module.exports = __webpack_public_path__ + "img/full3-min.d4de475f.png";